
































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { StreamUtils } from "xlsx/types";
import { VueEditor } from "vue2-editor";
import { component } from "vue/types/umd";
var parser = new DOMParser();
@Component({
  components: {
    VueEditor,
  },
})
export default class NotificationComponent extends Vue {
  @Action("showNotification", { namespace: "application" })
  showNotification: any;
  header = [
    { text: "Event", value: "Event", sortable: false },
    { text: "Recipient", value: "Recipient", sortable: false },
    { text: "Notification Type", value: "NotificationType", sortable: false },
    { text: "", value: "Meassage", sortable: false },
  ];
  items = [];
  pObject = {}; //stores paragraphs
  sObject = {}; //stores subjects
  tempId = {}; //stores templateIds
  languages = ["English", "French", "Spanish"];
  lang = "English";
  search = "";
  headerString =
    "<!DOCTYPE html><html><head><meta charset='utf-8' /><title>IUCN - Grants Portal</title></head><body><div style='font-family:Helvetica,Arial,sans-serif;border-collapse:collapse;width:100% !important;font-family:Helvetica,Arial,sans-serif;padding:0;' border='0' cellpadding='0' cellspacing='0' width='100%'>";
  footerString = "</div></body></html>";
  messageTemplate = "";
  toobar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    ["link"], // remove formatting button
  ];
  disabled = false;
  //loads notification Info
  mounted() {
    this.$services.document.Notification().then((data) => {
      data.Notification.forEach((element) => {
        let data = {};
        data["Event"] = element.Event;
        data["Recipient"] = element.Recipient;
        data["NotificationType"] = element.NotificationType;
        this.stringToHTML(element.templates);
        data["Message"] = this.pObject;
        data["subject"] = this.sObject;
        data["Id"] = this.tempId;
        data["Show"] = false;
        data["tempShow"] = false;
        data["SelectedKey"] = "English";
        this.pObject = {};
        this.sObject = {};
        this.tempId = {};
        this.items.push(data);
      });
    });
  }
  //takes p tags of each template to display on v-editor
  stringToHTML(html) {
    html.forEach((template) => {
      let lanArray = "";
      let templates = {};
      let key = String(template.lang);
      var doc = parser.parseFromString(template.template, "text/html");
      let divTags = doc.getElementsByTagName("div");
      for (let i = 0; i <= divTags.length - 1; i++) {
        for (let j = 0; j <= divTags[i].children.length - 1; j++) {
          lanArray = lanArray + divTags[i].children[j].outerHTML;
        }
      }
      switch (key) {
        case "en-US":
          this.sObject["English"] = template.Subject;
          this.pObject["English"] = lanArray;
          this.tempId["English"] = template.MessageTemplateId;
        case "fr-FR":
          this.sObject["French"] = template.Subject;
          this.pObject["French"] = lanArray;
          this.tempId["French"] = template.MessageTemplateId;
        case "es-ES":
          this.sObject["Spanish"] = template.Subject;
          this.pObject["Spanish"] = lanArray;
          this.tempId["Spanish"] = template.MessageTemplateId;
      }
    });
  }
  //displays dialog box
  showMessage(item) {
    item.tempShow = true;
    item.SelectedKey = this.lang;
  }
  //save the file
  onUpdate(message, id, subject, event) {
    let updateData = {};
    let tempMessage = this.headerString.concat(message);
    this.messageTemplate = tempMessage.concat(this.footerString);
    updateData["template"] = this.messageTemplate;
    updateData["subject"] = subject;
    this.$services.document.updateNotification(id, updateData).then((data) => {
      if (data.data.Result == "OK") {
        this.showNotification({
          text: this.$t("Notification Template updated"),
          isHtml: true,
          color: "success",
        });
      } else {
        this.showNotification({
          text: this.$t("Error"),
          isHtml: true,
          color: "error",
        });
      }
    });
    updateData = {};
  }
}
